module.exports = __webpack_public_path__ + "r-v3/img/icon-circle-graph_on.87ec369c.svg";